package io.noartcode.models

data class ProjectItem(
    val title:String,
    val description:String,
    val tags:List<String>,
    val link:String
)
